import styled from "@emotion/styled";

// Main container
export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 63.8% 36.2%;
  height: 100%;

  & > * {
    padding: 3rem 2rem;
  }
`;
export const HomeContainer = styled.div`
  display: grid;
  grid-template-rows: 10% 30% 60%;
`;
export const H1 = styled.h1``;
export const Span = styled.span``;
export const H2 = styled.h2``;
// export const H2 = styled.h2`
// margin-top:80px;`;
export const NotificationContainer = styled.div`
  // display: grid;
  background-color: #fff;
  border-left: 1px solid #e4e4e4;
`;

export const displayColor = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${(p) => (p.isTaskDone ? "yellow" : "red")};
`;
export const Task = styled.div`
margin-top: 20px;
margin-bottom: 20px;
box-sizing: border-box;
`;
export const Tasks = styled.div`
border-bottom: 1px solid #e4e4e4`;
export const TaskName = styled.div`
font-weight: 400;
line-height: 14px;
font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
margin-right: 10px;
`;
export const TaskDate = styled.div`
font-weight: 700;
margin-top: 8px;
font-size: 10px;
line-height: 10px;
`;

export const TasksCreate = styled.div``;
export const TaskInfo = styled.div``;

export const SelectContainer = styled.div`
  display: grid;
  grid-template-rows: 50% 50%;


  align-items: center;

  & form {
    width: 240px;
    justify-self: flex-end;
    position:absolute;
    
  }
`;

export const ProgressContainer = styled.div`
  display: grid;
  margin-top:50px;
 
  grid-template-columns: 80% 20%;
  align-items: center;
  gap: 2rem;
 
  
`;
export const DisplayTasks = styled.div`
  display: grid;
  margin: 2rem 0rem;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  font-size: 12px;
  font-weight: 400;
`;
export const SingleTaskContainer = styled.div`
  display: grid;
  margin: 0.7rem 0;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
  font-size: 12px;
  font-weight: 400;
`;
export const DisplayColor = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${(p) => (p.isTaskDone ? "yellow" : "red")};
`;
export const TaskContainer = styled.div``;
export const NameOfTask = styled.div``;
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;